import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'GWB',
  CLIENT_ID: '9',
  COUNTRY: 'gw'
}

export default config
